import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth.jsx";
import { Icon } from "../components/Icons.jsx";
import Seo from "../components/Seo.jsx";

export default function SignIn() {
  const { user, signInWithEmail, signOut, isSupabaseConfigured } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  if (user && !user.guest) return <Navigate to="/journal" replace />;

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const res = await signInWithEmail(email.trim());
    setBusy(false);
    if (res.ok) setSent(true);
    else setError(res.error || "Could not send sign-in link.");
  }

  return (
    <>
      <Seo
        title="Sign In · Simple Meditation World"
        description="Sign in to sync your saved techniques and journal entries across devices."
        path="/sign-in"
      />
      <section className="section-ivory" style={{ paddingTop: 100, paddingBottom: 80 }}>
        <div className="container" style={{ maxWidth: 480 }}>
          <span className="eyebrow">Sign in</span>
          <h1 style={{ fontFamily: "var(--serif)", fontWeight: 400, fontSize: "clamp(32px, 4vw, 48px)", marginTop: 14 }}>
            Your <em>practice map</em>
          </h1>
          <p style={{ color: "var(--muted)", marginTop: 14 }}>
            {isSupabaseConfigured
              ? "Enter your email. We'll send a magic link — no password, no spam."
              : "Account hosting isn't configured yet. Your saves and journal are kept on this device for now."}
          </p>

          {!isSupabaseConfigured && (
            <div style={{ marginTop: 22, padding: 16, background: "rgba(229,193,106,0.08)", border: "1px solid rgba(229,193,106,0.2)", borderRadius: 10, fontSize: 13, color: "var(--muted)" }}>
              <b>Site owner:</b> Add <code>VITE_SUPABASE_URL</code> and <code>VITE_SUPABASE_ANON_KEY</code> to <code>.env.local</code> to enable accounts. Until then, the journal lives in localStorage.
            </div>
          )}

          {sent ? (
            <div style={{ marginTop: 32, padding: 22, background: "#fff", border: "1px solid var(--border)", borderRadius: 10 }}>
              <h3 style={{ fontFamily: "var(--serif)", fontWeight: 500, marginBottom: 8 }}>Check your email.</h3>
              <p style={{ color: "var(--muted)", fontSize: 14, margin: 0 }}>
                We sent a sign-in link to <b>{email}</b>. Open it on this device to continue.
              </p>
            </div>
          ) : (
            <form onSubmit={submit} style={{ marginTop: 32 }}>
              <label htmlFor="email" style={{ display: "block", fontFamily: "var(--mono)", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", color: "var(--muted)", marginBottom: 8 }}>Email</label>
              <input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                style={{ width: "100%", padding: "12px 14px", border: "1px solid var(--border)", borderRadius: 8, fontSize: 15, background: "#fff" }}
              />
              {error && <p style={{ color: "#b04a3a", fontSize: 13, marginTop: 8 }}>{error}</p>}
              <button className="btn btn-primary" type="submit" disabled={busy || !email} style={{ marginTop: 18 }}>
                {busy ? "Sending..." : isSupabaseConfigured ? "Email me a link" : "Continue as guest"} {Icon.arrowSm()}
              </button>
            </form>
          )}

          {user?.guest && (
            <div style={{ marginTop: 28, fontSize: 13, color: "var(--muted)" }}>
              Signed in as guest: <b>{user.email}</b> ·{" "}
              <button onClick={signOut} style={{ background: "none", border: "none", color: "var(--copper)", cursor: "pointer", padding: 0, font: "inherit" }}>
                Sign out
              </button>
            </div>
          )}

          <p style={{ marginTop: 40, fontSize: 13, color: "var(--muted)" }}>
            <Link to="/journal" style={{ color: "var(--copper)" }}>Go to journal →</Link>
          </p>
        </div>
      </section>
    </>
  );
}
